import {connect} from 'react-redux';
import _ from '../../shared/utils/ObjectUtils';

const UserHasPermission = ({
    appModule,
    action,
    userPermissions,
    children
}) => {
    if(userHasPermission(appModule, action, userPermissions)) return children;
    return null;
};

function userHasPermission(appModule, action, userPermissions) {
    if(userPermissions.includes('ROOT')) return true;
    if(appModule === "TERMINAL" || appModule === "VISIT" || appModule === "VISITOR" || appModule === "RULE") return false;//TO-DO remove once modules are finished
    if(_.isNilOrEmpty(appModule) || _.isNilOrEmpty(action)) return true;

    const neededPermission = action.concat('_', appModule);
    return userPermissions.indexOf(neededPermission) !== -1;
}

const appModules = {
    USER: 'USER',
    ENTITY: 'ENTITY',
    RULE: 'RULE',
    ROLE: 'ROLE',
    TERMINAL: 'TERMINAL',
    INTERFACE: 'INTERFACE',
    CONSOLE_USER: 'CONSOLE_USER',
    SCHEDULE_ENTRIES: 'SCHEDULE_ENTRIES',
    INTERFACE_READING: 'INTERFACE_READING',
    VISIT: 'VISIT',
    VISITOR: 'VISITOR',
    CHECK: 'CHECK',
    PARKING: 'PARKING',
    BILLING_REPORT:'BILLING_REPORT'
};

const modulesActions = {
    CREATE: 'CREATE',
    UPDATE: 'UPDATE',
    DELETE: 'DELETE',
    READ: 'READ',
    CHANGE: 'CHANGE',
    REQUEST: 'REQUEST',
    IN: 'IN',
    OUT: 'OUT'
};

const mapStateToProps = ({ authReducer }) => ({
    userPermissions: authReducer.user && authReducer.user.role ? authReducer.user.role.permissions : []
})

export default connect(
    mapStateToProps,
    null
)(UserHasPermission);

export {
    appModules,
    modulesActions,
    userHasPermission
}